import React from 'react';

const JS_RegExp_Assertions = () => {
  return (
    <div >
      <h1>JS_RegExp_Assertions</h1>
      <p>Placeholder component for: "JS RegExp Assertions"</p>
    </div>
  );
};

export default JS_RegExp_Assertions;
